import { useQuery } from "react-query";
import { getData } from "../../../../../newApis/dotNetApiMethods";
import * as ajaxEndpoints from "../../../../../api/ajax-endpoints";

export type TNextOfKinWorldCountry = {
  id?: number;
  name?: string;
  iso2?: string | null;
};

type TNextOfKinWorldCountriesResponse = {
  data: TNextOfKinWorldCountry[];
  message?: string;
  status?: boolean;
  status_code?: number;
};

const getNextOfKinWorldCountries = async () => {
  const { data } = await getData(ajaxEndpoints.WORLD_COUNTRIES);
  return data;
};

export default function useNextOfKinWorldCountries() {
  return useQuery<TNextOfKinWorldCountriesResponse>(
    ["getNextOfKinWorldCountries"],
    getNextOfKinWorldCountries,
    {
      refetchOnWindowFocus: true,
    },
  );
}
